import { Grid2 } from "@mui/material";
import pageNotFound from "../../assets/imgs/page-not-found.png";
import { useNavigate } from "react-router-dom";
import Navbar from "../../pages/Navbar/Navbar";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="content-body">
        <div
          style={{
            alignContent: "center",
            margin: "auto",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <img
            src={pageNotFound}
            alt="pageNotFound"
            style={{
              margin: "auto",
            }}
          />
          <h4
            style={{
              color: "#337ab7",
            }}
          >
            Oops Page Not Found !
          </h4>
        </div>

        <Grid2
          alignItems={"center"}
          justifyContent="center"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button
              className="create-btn"
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default PageNotFound;
